// @ts-nocheck

import { FunctionalComponent, h } from "preact";
import { Img } from "react-image";
import styled, { css } from "styled-components";

const StyledImg = styled(Img)`
    width: 100% !important;
    height: auto !important;
    ${props =>
        props.displayMode === "fullscreen" &&
        css`
            height: 100vh !important;
            width: auto !important;
    `};
`;

export const Image: FunctionalComponent = ({
    src,
    thumbnail,
    displayMode,
    onLoaded
}) => {
    return (
        <StyledImg
            imgPromise={onLoaded}
            src={src}
            displayMode={displayMode}
            loader={<StyledImg src={thumbnail} displayMode={displayMode} />}
        />
    );
};
